import cartApi from './cart-api';

export default {
    async getPaymentHistory(fromYear) {
        if (!fromYear) {
            fromYear = '2000';
        }
        let allPayments = await cartApi.getAllPaymentsAfter(fromYear);

        const monthList = [];

        // group by month
        let mappedPayments = allPayments.map(payment => {
            const newDataPoint = {};
            newDataPoint.date = payment.orderDate.substring(0, 7);
            newDataPoint.price = payment.netCost.price;
            if (!monthList.includes(newDataPoint.date)) {
                monthList.push(newDataPoint.date);
            }
            return newDataPoint;
        });

        const aggregateValue = [];
        const aggregateOrderCount = [];
        let currMonth = new Date().toJSON().substring(0, 7);
        // this.$log.info('Current month: '+ currMonth);

        mappedPayments.forEach(payment => {
            let thisPrice = 0;
            if (payment.price) {
                thisPrice = payment.price;
            }

            if (!aggregateOrderCount[payment.date]) {
                aggregateOrderCount[payment.date] = 1;
            } else {
                aggregateOrderCount[payment.date] += 1;
            }

            if (!aggregateValue[payment.date]) {
                aggregateValue[payment.date] = thisPrice;
                // this.$log.info('Created new month: '+ payment.date + ' -> ' + thisPrice);
            } else {
                aggregateValue[payment.date] += thisPrice;
                // this.$log.info('Updated month: '+ payment.date + ' -> ' + aggregate[payment.date]);
            }
        });
        
        const ordersByMonth = [];
        monthList.forEach(month => {
            const dataPoint = {
                month: month,
                orderCount: aggregateOrderCount[month],
                orderValue: aggregateValue[month],
            };
            ordersByMonth.push(dataPoint);
        });

        let results = {
            ordersByMonth: ordersByMonth,
            currMonth: currMonth,
        }
        return results;
    }
}